"use client";

// =============================================================================
// CATEGORY PILL
// =============================================================================
// Badge/pill showing category label (e.g. "Cross-Platform Design", "Email")
// Outlined by default, fills with brand color on hover/touch/peek
// Used by both OrbCard (projects) and ContactCard (contact moons)

interface CategoryPillProps {
  label: string;
  color: string; // Brand color for fill + border
  filled: boolean; // true = solid fill, false = outlined with backdrop blur
  fontSize?: number; // Default 16
  padding?: string; // Default "4px 12px"
  marginBottom?: number; // Default 10
}

export function CategoryPill({
  label,
  color,
  filled,
  fontSize = 16,
  padding = "4px 12px",
  marginBottom = 10,
}: CategoryPillProps) {
  return (
    <span
      style={{
        display: "inline-block",
        fontSize,
        fontWeight: 900,
        padding,
        borderRadius: 999,
        marginBottom,
        textTransform: "uppercase",
        letterSpacing: "0.06em",
        whiteSpace: "nowrap",
        color: filled ? "#000" : color,
        backgroundColor: filled ? color : `${color}15`,
        border: `1px solid ${filled ? color : `${color}35`}`,
        backdropFilter: filled ? undefined : "blur(12px)",
        WebkitBackdropFilter: filled ? undefined : "blur(12px)",
        transition: "all 0.2s ease",
      }}
    >
      {label}
    </span>
  );
}
